import React, { useState } from "react";
import CreatePublish from "./CreatePublish";
import PreUpload from "./PreUpload";
import PreMcq from "./PreMcq";
import DraftPublish from "./DraftPublish";
import OperationType from "../../Enum/OperationTypeEnum";
import {
  Box,
  Paper,
  Typography,
  Button,
  Chip,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { CheckCircle2, ListChecks, Award, Timer } from "lucide-react";

const ACCENT = "#f77f00";
const ACCENT_SOFT = "#fff4e5";
const BORDER = "#e6e9ef";
const TEXT_PRIMARY = "#1f2733";
const TEXT_SECONDARY = "#5b6472";
const BG_SOFT = "#f8f9fb";

const QuestionListAssessment = ({
  change,
  questions,
  setQuestions,
  assessmentDetails,
  setAssessmentDetails,
  operationType,
  total_marks,
  componentType,
  name,
  redirectStateData,
  isChecked,
  selectedBox,
}) => {
  const [click, setClick] = useState(false);
  console.log("assessmentDetails", assessmentDetails);
  console.log(selectedBox, "selectedBox");
  console.log(questions, "questions");
  return (
    <>
      {!click && (
        <div className="preview_transprant_body">
          <Paper
            elevation={6}
            className="preview_container"
            sx={{
              p: 3,
              borderRadius: "16px",
              background: "#fff",
              border: `1px solid ${BORDER}`,
              position: "relative",
              maxHeight: "92vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={() => change(false)}
              size="small"
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                color: TEXT_SECONDARY,
                background: BG_SOFT,
                border: `1px solid ${BORDER}`,
                "&:hover": { background: ACCENT_SOFT, color: ACCENT },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            {/* Header */}
            <Box sx={{ mb: 2, pr: 5 }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 700,
                  color: TEXT_PRIMARY,
                  letterSpacing: "-0.2px",
                }}
              >
                {name || "Review & Publish"}
              </Typography>
              <Typography sx={{ fontSize: "12.5px", color: TEXT_SECONDARY }}>
                Review all questions and answers before publishing
              </Typography>
            </Box>

            {/* Stat Cards */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                gap: 1.5,
                mb: 2.5,
              }}
            >
              {/* Total Questions */}
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  border: `1px solid ${BORDER}`,
                  background: BG_SOFT,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                }}
              >
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "10px",
                    background: ACCENT_SOFT,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ListChecks size={18} color={ACCENT} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: TEXT_SECONDARY,
                      letterSpacing: "0.4px",
                    }}
                  >
                    TOTAL QUESTIONS
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      color: TEXT_PRIMARY,
                      lineHeight: 1.1,
                    }}
                  >
                    {questions?.length || 0}
                  </Typography>
                </Box>
              </Paper>

              {/* Total Marks */}
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  border: `1px solid ${BORDER}`,
                  background: BG_SOFT,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                }}
              >
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "10px",
                    background: ACCENT_SOFT,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Award size={18} color={ACCENT} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: TEXT_SECONDARY,
                      letterSpacing: "0.4px",
                    }}
                  >
                    TOTAL MARKS
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      color: TEXT_PRIMARY,
                      lineHeight: 1.1,
                    }}
                  >
                    {total_marks}
                  </Typography>
                </Box>
              </Paper>

              {/* Duration */}
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  border: `1px solid ${BORDER}`,
                  background: BG_SOFT,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                }}
              >
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "10px",
                    background: ACCENT_SOFT,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Timer size={18} color={ACCENT} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: TEXT_SECONDARY,
                      letterSpacing: "0.4px",
                    }}
                  >
                    DURATION
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      color: TEXT_PRIMARY,
                      lineHeight: 1.1,
                    }}
                  >
                    {assessmentDetails?.total_duration || 0} min
                  </Typography>
                </Box>
              </Paper>
            </Box>

            <Divider sx={{ borderColor: BORDER, mb: 2 }} />

            {/* Questions List */}
            <Box
              className="preview_question_lists orange-scrollBar"
              sx={{
                overflowY: "auto",
                pr: 1,
                flex: 1,
                minHeight: 0,
              }}
            >
              {questions.length > 0 &&
                questions.map((question, index) =>
                  question.question_type === "false" ? (
                    <PreMcq
                      key={index}
                      nextQuestion={index}
                      question={question}
                    />
                  ) : (
                    <PreUpload
                      key={index}
                      nextQuestion={index}
                      question={question}
                      selectedBox={selectedBox}
                    />
                  ),
                )}
            </Box>

            {/* Publish Button */}
            <Box
              sx={{
                mt: 2,
                pt: 2,
                borderTop: `1px solid ${BORDER}`,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                startIcon={<RocketLaunchIcon />}
                onClick={() => setClick(true)}
                sx={{
                  background: ACCENT,
                  color: "#fff",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "13.5px",
                  px: 3,
                  py: 0.9,
                  boxShadow: "0 4px 12px rgba(247,127,0,0.25)",
                  "&:hover": {
                    background: "#e56f00",
                    boxShadow: "0 6px 16px rgba(247,127,0,0.35)",
                  },
                }}
              >
                Publish
              </Button>
            </Box>
          </Paper>
        </div>
      )}
      {click && operationType === OperationType.CREATE && (
        <CreatePublish
          setClick={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          questions={questions}
          componentType={componentType}
          redirectStateData={redirectStateData}
          isChecked={isChecked}
          selectedBox={selectedBox}
        />
      )}

      {click && operationType === OperationType.UPDATE && (
        <DraftPublish
          setClick={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          questions={questions}
          componentType={componentType}
          isChecked={isChecked}
          selectedBox={selectedBox}
        />
      )}
    </>
  );
};

export default QuestionListAssessment;
